import ApplicationController from '../../support/application_controller'

export default class extends ApplicationController {

  static targets = [
    'frame',
    'scrollbars'
  ]

  scrollIntoView({ currentTarget }) {
    (this.frame ?? currentTarget).scrollIntoView()
  }

  scrollToTop() {
    this.scrollbarsTarget.scrollTop = 0
  }

  get frame() {
    if (this.hasFrameTarget) {
      return this.frameTarget
    }
    if (this.element.tagName === 'TURBO-FRAME') {
      return this.element
    }
    return null
  }

}
